import React, { useEffect } from 'react'
import { FormView } from './FormView'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { Container, Row } from 'react-bootstrap'
import { AiFeature } from '../../../../../models/AiFeature'
import {
  selectFormAiFeaturesForCurrentMeetingTemplate,
  selectFormEventPollingEnabled,
  selectFormsLoading,
  selectShouldPollFormEvents,
  startFormEventsPolling,
  stopFormEventsPolling,
} from '../../../../../store/meetingSummary/forms'
import { FormPoller } from './Poller/FormPoller'

export const FormBody: React.FC = () => {
  const dispatch = useAppDispatch()

  const formsLoading = useAppSelector(selectFormsLoading)
  const aiForms = useAppSelector(selectFormAiFeaturesForCurrentMeetingTemplate)
  const shouldPollEvents = useAppSelector(selectShouldPollFormEvents)
  const pollingEnabled = useAppSelector(selectFormEventPollingEnabled)

  useEffect(() => {
    if (shouldPollEvents) {
      dispatch(startFormEventsPolling())
    } else {
      dispatch(stopFormEventsPolling())
    }
  }, [dispatch, shouldPollEvents])

  if (formsLoading || pollingEnabled) {
    return (
      <div className='d-flex px-4 py-3'>
        <div className='skeleton w-100 loading-result-skeleton' style={{ height: '24px' }} />
      </div>
    )
  }

  if (!aiForms.length) {
    return <div className='paragraph-medium-extended zocks-text-gray-500 py-1 pe-4 ps-4'>No forms found for this meeting type</div>
  }

  return (
    <Container className='w-100 mw-100 p-0'>
      <Row className='my-4'>
        {aiForms.map((aiFeature: AiFeature) => (
          <div key={aiFeature.id}>
            <FormPoller aiFeatureId={aiFeature.id} />
            <FormView aiFeature={aiFeature} />
          </div>
        ))}
      </Row>
    </Container>
  )
}
